import React from 'react';
import { FormProgressBarProps } from './FormWizardTypes';

/**
 * FormProgressBar - Shows progress through the form fields
 * Displays both a visual progress bar and text indicator
 */
export function FormProgressBar({ current, total, className = '' }: FormProgressBarProps) {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className={`w-full ${className}`}>
      {/* Progress Bar */}
      <div className="w-full bg-muted rounded-full h-2 mb-2 overflow-hidden">
        <div
          className="bg-brand-brand_purple h-2 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      {/* Progress Text */}
      <div className="flex justify-between items-center text-sm text-muted-foreground">
        <span>Question {current} of {total}</span>
        <span>{percentage}%</span>
      </div>
    </div>
  );
}
